import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)
 

import AuthUsers from '../modules/login/store'

import AdmCompany from '../modules/admin/company/store'
import AdmDashboard from '../modules/admin/dashboard/store'

import CompanyDashboard from '../modules/company/dashboard/store'
import CompanyRecurrent from '../modules/company/recurrent/store'
import CompanyTransaction from '../modules/company/transaction/store'
import CompanyCustomer from '../modules/company/customer/store'

const modules = {
    AuthUsers,
    AdmCompany, 
    AdmDashboard, 
    CompanyDashboard, 
    CompanyRecurrent, 
    CompanyTransaction, 
    CompanyCustomer, 
}

const store = new Vuex.Store({
    modules,
  })

export default store;